import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { globals } from '../globals';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Configuracao } from '../models/configuracao';
import { AutenticacaoService } from '../services/autenticacao.service';
import { Router } from '@angular/router';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { PlatformLocation } from '@angular/common';
import { AppConfigService } from '../services/app-config.service';
import { MatDialog } from '@angular/material';
import { CaptchaService } from '../services/captcha.service';
import { NotificacaoService } from '../services/notificacao.service';

@Component({
  selector: 'app-esqueceu-senha',
  templateUrl: './esqueceu-senha.component.html',
  styleUrls: ['./esqueceu-senha.component.scss']
})
export class EsqueceuSenhaComponent implements OnInit, OnDestroy {
  versao = environment.appVersion;
  anoAtual: number;
  carregando = false;
  configuracao: Configuracao;
  idVisual: any;
  email = '';
  desafio: string | null = null;
  erroRedefinir = false;
  mensagemRedefinir = '';

  urls = [];
  urlSelecionada = globals.apiUrl;

  showCaptcha = false;
  captchaWidgetId: string | null = null;

  private configuracaoSubscription$: Subscription;

  constructor(
    private elementRef: ElementRef,
    private autenticacaoService: AutenticacaoService,
    private router: Router,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private globalService: GlobalService,
    private platformLocation: PlatformLocation,
    private appConfigService: AppConfigService,
    public dialog: MatDialog,
    private captchaService: CaptchaService
  ) {}

  ngOnInit() {
    this.anoAtual = new Date().getFullYear();
    this.urls = this.appConfigService.getServerUrls();

    if (!this.urls.some((p) => p === this.urlSelecionada)) {
      this.urlSelecionada = undefined;
    }

    if (this.urls.length === 1) {
      this.urlSelecionada = this.urls[0];
    }

    // inscreve no evento de troca de configuração
    this.configuracaoSubscription$ = this.globalService.alterouConfiguracao.subscribe((conf) => {
      this.configuracao = conf;
    });

    this.dialog.closeAll();
    this.autenticacaoService.logoutLocal();

    const body = document.getElementsByTagName('body')[0];
    body.classList.add('off-canvas-sidebar');

    const card = document.getElementsByClassName('card')[0];

    if (card) {
      setTimeout(function () {
        // after 1000 ms we add the class animated to the login/register card
        card.classList.remove('card-hidden');
      }, 700);
    }
  }

  ngOnDestroy() {
    this.configuracaoSubscription$.unsubscribe();

    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-page');
    body.classList.remove('off-canvas-sidebar');
  }

  public onSubmit() {
    this.carregando = true;
    this.erroRedefinir = false;

    globals.apiUrl = this.urlSelecionada;
    localStorage.setItem('urlApi', this.urlSelecionada);

    this.executarCaptcha().finally();
  }

  private async executarCaptcha() {
    // Se não tem captcha instalado, reseta a senha diretamente.
    if (!this.captchaService.captchaHabilitado()) {
      this.redefinir();
      return;
    }

    const containerElement = this.elementRef.nativeElement.querySelector('#challenger-container') as HTMLElement;

    // O container não foi encontrado.
    if (!containerElement) {
      this.erroAoRedefinir(
        'Falha ao executar o script de verificação de segurança. Atualize a página e tente novamente.'
      );
      return;
    }

    try {
      this.showCaptcha = true;

      const captchaScript = await this.captchaService.carregarScript();

      if (!this.captchaWidgetId) {
        this.captchaWidgetId = captchaScript.render(containerElement, {
          sitekey: this.captchaService.buscarChaveCliente(),
          action: 'redefinirSenha',
          callback: (token: string) => {
            this.desafio = token;

            this.redefinir();
          },
          'error-callback': (errorCode: string) => {
            this.erroAoRedefinir(`Ocorreu um erro ao verificar se você é humano: ${errorCode}`);
          },
          'timeout-callback': () => {
            this.erroAoRedefinir(
              'Tempo limite excedido ao verificar se você é humano. Atualize a página e tente novamente.'
            );
          },
          theme: 'light',
          size: 'flexible',
          retry: 'never'
        });
      } else {
        captchaScript.reset(this.captchaWidgetId);
      }
    } catch (erro) {
      this.erroAoRedefinir(erro.message);
    }
  }

  private redefinir() {
    this.carregandoService.mostra('redefinirSenha');

    const url = location.origin + this.platformLocation.getBaseHrefFromDOM();

    this.autenticacaoService.esqueceuSenha(this.email, url, this.desafio).subscribe(
      () => {
        this.router.navigate(['/']).then(() => {
          this.carregandoService.esconde('redefinirSenha');
          this.notificacaoService.sucesso(
            'Operação Concluída com Sucesso!! Enviamos um email para você com as instruções para resetar a senha'
          );
          this.carregando = false;
        });
      },
      (erro: any) => {
        const mensagem =
          erro.status === 0
            ? 'Erro ao redefinir a senha do usuário'
            : erro.status === 400
              ? 'Não foi possível enviar o e-mail de recuperação de senha no momento devido a uma oscilação temporária em nossos serviços de envio. Por favor, tente novamente em instantes ou entre em contato com o suporte.'
              : erro.error;

        this.erroAoRedefinir(mensagem);
        this.autenticacaoService.logoutLocal();
        this.carregandoService.esconde('redefinirSenha');
      }
    );
  }

  private erroAoRedefinir(erro: string) {
    this.carregando = false;
    this.showCaptcha = false;
    this.erroRedefinir = true;
    this.mensagemRedefinir = erro;

    this.desafio = null;
  }
}
